<template>
  <div class="tabs-wrapper">
    <div class="tabs container" v-if="month === '202006'">
      <Tab06
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :index="index"
        :month="month"
      />
    </div>
    <div class="tabs container" v-if="month === '202007'">
      <Tab07
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :index="index"
        :month="month"
      />
    </div>
    <div class="tabs container" v-if="month === '202008'">
      <Tab08
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :index="index"
        :month="month"
      />
    </div>
    <div class="tabs container" v-if="month === '202010'">
      <Tab10kantou
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :index="index"
        :month="month"
      />
    </div>
    <div class="tabs container" v-if="month === '2021'">
      <Tab2021
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :index="index"
        :month="month"
      />
    </div>
  </div>
</template>

<script>
import Tab06 from '@/components/organisms/202006/tab/Tab.vue'
import Tab07 from '@/components/organisms/202007/tab/Tab.vue'
import Tab08 from '@/components/organisms/202008/tab/Tab.vue'
import Tab10kantou from '@/components/organisms/202010kantou/tab/Tab.vue'
import Tab2021 from '@/components/organisms/2021tsuruha/tab/Tab.vue'
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    },
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Tab06,
    Tab07,
    Tab08,
    Tab10kantou,
    Tab2021
  }
}
</script>

<style lang="sass" scoped>
.tabs
  display: flex
  justify-content: center
  align-items: center
</style>
